export default __webpack_public_path__ + "media/images/images/icons/loading-430fc2eb2b9556d6f006db257b282429.gif";